import { render, staticRenderFns } from "./p295_pickup.vue?vue&type=template&id=347cd5c2"
import script from "./p295_pickup.vue?vue&type=script&lang=js"
export * from "./p295_pickup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {P295GoogleAutocomplete: require('/root/containers/hermes_eshop/components/hyper/p295/p295_google_autocomplete.vue').default,P295Point: require('/root/containers/hermes_eshop/components/hyper/p295/p295_point.vue').default})
